import React from "react";

const Title = () => {
  return (
    <p className="h-[30px] w-[200px] animate-pulse rounded-full bg-slate-700/20"></p>
  );
};

export default Title;
